module.exports = __webpack_public_path__ + "img/01-nota.861d1e68.png";